var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBetterThanReviewSitesWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 203.04 144.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16 {\n        stroke: #fff;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26 {\n        fill: #fff;\n      }\n\n      .cls-27 {\n        fill: #0bf415;\n      }\n\n      .cls-28 {\n        fill: #020004;\n        isolation: isolate;\n        opacity: .18;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-13, .cls-14, .cls-18, .cls-19, .cls-20, .cls-21, .cls-15, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-16 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-13, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-16 {\n        stroke-width: 2px;\n      }\n\n      .cls-13, .cls-15 {\n        fill: none;\n      }\n\n      .cls-14 {\n        stroke-width: 4px;\n      }\n\n      .cls-14, .cls-16 {\n        fill: rgba(255, 255, 255, .8);\n      }\n\n      .cls-18 {\n        stroke: url(#linear-gradient-3);\n      }\n\n      .cls-19 {\n        stroke: url(#linear-gradient-2);\n      }\n\n      .cls-20 {\n        stroke: url(#linear-gradient-9);\n      }\n\n      .cls-21 {\n        stroke: url(#linear-gradient-8);\n      }\n\n      .cls-22 {\n        stroke: url(#linear-gradient);\n      }\n\n      .cls-23 {\n        stroke: url(#linear-gradient-15);\n      }\n\n      .cls-24 {\n        stroke: url(#linear-gradient-16);\n      }\n\n      .cls-25 {\n        stroke: url(#linear-gradient-17);\n      }\n\n      .cls-26 {\n        stroke: url(#linear-gradient-10);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -272.82,
    y1: 57.3,
    x2: -261.29,
    y2: 57.3,
    gradientTransform: "translate(287 141.76) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -247.73,
    x2: -236.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 43.88,
    x2: -236.21,
    y2: 43.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -10117,
    y1: 102.25,
    x2: -10106.61,
    y2: 102.25,
    gradientTransform: "translate(-10060.59 141.76) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -10104.51,
    y1: 102.25,
    x2: -10094.13,
    y2: 102.25,
    gradientTransform: "translate(-10060.59 141.76) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -10092.02,
    y1: 102.25,
    x2: -10081.63,
    y2: 102.25,
    gradientTransform: "translate(-10060.59 141.76) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -10079.53,
    y1: 102.25,
    x2: -10069.15,
    y2: 102.25,
    gradientTransform: "translate(-10060.59 141.76) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -3116.47,
    x2: -3104.94,
    gradientTransform: "translate(-2927.61 141.76) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -3091.38,
    x2: -3079.85,
    gradientTransform: "translate(-2927.61 141.76) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -3116.47,
    y1: 43.87,
    x2: -3079.86,
    y2: 43.87,
    gradientTransform: "translate(-2927.61 141.76) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -7273.35,
    y1: 102.25,
    x2: -7262.97,
    y2: 102.25,
    gradientTransform: "translate(7419.98 141.76) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -7260.87,
    y1: 102.25,
    x2: -7250.48,
    y2: 102.25,
    gradientTransform: "translate(7419.98 141.76) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -7248.37,
    y1: 102.25,
    x2: -7237.99,
    y2: 102.25,
    gradientTransform: "translate(7419.98 141.76) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -7235.89,
    y1: 102.25,
    x2: -7225.5,
    y2: 102.25,
    gradientTransform: "translate(7419.98 141.76) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -217.65,
    y1: 45.26,
    x2: -198.95,
    y2: 45.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -173.67,
    y1: 45.26,
    x2: -154.97,
    y2: 45.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -217.65,
    y1: 21.74,
    x2: -154.97,
    y2: 21.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -10203.23,
    y1: 119.56,
    x2: -10185.02,
    y2: 119.56,
    gradientTransform: "translate(-10060.59 141.76) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -10181.33,
    y1: 119.56,
    x2: -10163.13,
    y2: 119.56,
    gradientTransform: "translate(-10060.59 141.76) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -10159.44,
    y1: 119.56,
    x2: -10141.23,
    y2: 119.56,
    gradientTransform: "translate(-10060.59 141.76) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -10137.54,
    y1: 119.56,
    x2: -10119.34,
    y2: 119.56,
    gradientTransform: "translate(-10060.59 141.76) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m36.25,68.97h-7.53c0-1.89,1.42-3.47,3.25-3.73.17-.03.34-.03.51-.03s.35,0,.51.03c1.82.26,3.25,1.84,3.25,3.73Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 32.49,
    y1: 66.05,
    x2: 32.49,
    y2: 60.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 32.49,
    cy: 58.64,
    r: 2.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m62.96,79.25v20.97c0,4.83-3.37,8.9-7.88,9.99-.77.19-1.57.28-2.39.28H12.27c-5.65,0-10.27-4.62-10.27-10.27v-20.97c0-5.65,4.62-10.27,10.27-10.27h40.69c2.37.05,4.54.92,6.26,2.34,2.28,1.88,3.74,4.74,3.74,7.92h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 19.94,
    cy: 84.46,
    r: 4.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 45.04,
    cy: 84.46,
    r: 4.77
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m15.18,93.04h34.61v.96c0,4.82-3.91,8.73-8.73,8.73h-17.16c-4.82,0-8.73-3.91-8.73-8.73v-.96h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m68.14,38.8v10.41c0,3.73-3.05,6.79-6.79,6.79h-4.92l-5.82,5.85v-5.85H13.02c-3.73,0-6.79-3.05-6.79-6.79v-10.41c0-3.73,3.06-6.79,6.79-6.79h48.33c3.73,0,6.79,3.05,6.79,6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m63.7,34.27v10.5c0,3.77-3.08,6.85-6.85,6.85h-4.95l-5.86,5.9v-5.9H8.12c-3.77,0-6.85-3.08-6.85-6.85v-10.5c0-3.77,3.08-6.85,6.85-6.85h48.73c3.77,0,6.85,3.08,6.85,6.85Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "51.22 34.58 49.62 37.83 46.03 38.35 48.63 40.88 48.01 44.45 51.22 42.77 54.43 44.45 53.82 40.88 56.42 38.35 52.83 37.83 51.22 34.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "38.73 34.58 37.13 37.83 33.54 38.35 36.14 40.88 35.53 44.45 38.73 42.77 41.94 44.45 41.33 40.88 43.92 38.35 40.34 37.83 38.73 34.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.24 34.58 24.63 37.83 21.05 38.35 23.65 40.88 23.03 44.45 26.24 42.77 29.45 44.45 28.84 40.88 31.44 38.35 27.84 37.83 26.24 34.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "13.75 34.58 12.15 37.83 8.56 38.35 11.16 40.88 10.54 44.45 13.75 42.77 16.96 44.45 16.35 40.88 18.94 38.35 15.36 37.83 13.75 34.58"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m166.79,68.97h7.53c0-1.89-1.42-3.47-3.25-3.73-.17-.03-.34-.03-.51-.03s-.35,0-.51.03c-1.82.26-3.25,1.84-3.25,3.73h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 170.56,
    y1: 66.05,
    x2: 170.56,
    y2: 60.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 170.56,
    cy: 58.64,
    r: 2.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m201.04,79.25v20.97c0,5.65-4.62,10.27-10.27,10.27h-40.43c-1.34,0-2.62-.26-3.8-.74-3.78-1.51-6.47-5.23-6.47-9.53v-20.97c0-2.85,1.18-5.44,3.07-7.31,1.51-1.48,3.45-2.5,5.62-2.84.51-.08,1.04-.12,1.57-.12h40.43c5.65,0,10.27,4.62,10.27,10.27Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 183.1,
    cy: 84.46,
    r: 4.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 158.01,
    cy: 84.46,
    r: 4.77
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m179.14,102.73h-17.16c-4.82,0-8.73-3.91-8.73-8.73v-.96h34.61v.96c0,4.82-3.91,8.73-8.73,8.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m134.9,38.8v10.41c0,3.73,3.06,6.79,6.79,6.79h4.92l5.82,5.85v-5.85h37.6c3.73,0,6.79-3.05,6.79-6.79v-10.41c0-3.73-3.06-6.79-6.79-6.79h-48.33c-3.73,0-6.79,3.05-6.79,6.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m139.35,34.27v10.5c0,3.77,3.08,6.85,6.85,6.85h4.95l5.86,5.9v-5.9h37.91c3.77,0,6.85-3.08,6.85-6.85v-10.5c0-3.77-3.08-6.85-6.85-6.85h-48.73c-3.77,0-6.85,3.08-6.85,6.85h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "151.81 34.58 153.42 37.83 157.01 38.35 154.42 40.88 155.02 44.45 151.81 42.77 148.61 44.45 149.22 40.88 146.63 38.35 150.21 37.83 151.81 34.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "164.31 34.58 165.91 37.83 169.5 38.35 166.9 40.88 167.52 44.45 164.31 42.77 161.1 44.45 161.72 40.88 159.11 38.35 162.7 37.83 164.31 34.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "176.79 34.58 178.4 37.83 181.99 38.35 179.4 40.88 180 44.45 176.79 42.77 173.58 44.45 174.2 40.88 171.61 38.35 175.19 37.83 176.79 34.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "189.29 34.58 190.89 37.83 194.48 38.35 191.88 40.88 192.5 44.45 189.29 42.77 186.08 44.45 186.69 40.88 184.09 38.35 187.69 37.83 189.29 34.58"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m107.29,69.36h-13.21c0-1.76.71-3.38,1.85-4.56,1.01-1.06,2.35-1.77,3.85-1.98.29-.04.6-.06.9-.06s.61.02.91.06c1.5.21,2.85.92,3.85,1.98,1.14,1.18,1.85,2.8,1.85,4.56Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 100.69,
    y1: 64,
    x2: 100.69,
    y2: 55.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 100.69,
    cy: 51.24,
    r: 4.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m161.38,80.41v32.08h-7.26v17.64c0,6.6-5.4,12-12,12H59.25c-6.6,0-12-5.4-12-12v-17.64h-7.26v-32.08c0-3.36.99-6.63,2.76-9.43.44-.7.93-1.37,1.47-2,.6-.71,1.27-1.38,1.99-2h5.92c2.56.05,4.95.87,6.97,2.37h83.18c1.58-1.16,3.4-1.92,5.34-2.23.65-.09,1.26-.14,1.88-.14h5.67c.12.1.24.2.36.31.58.53,1.13,1.09,1.62,1.69.55.63,1.04,1.3,1.48,2,1.78,2.81,2.75,6.08,2.75,9.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m154.12,81.35v48.78c0,6.6-5.4,12-12,12H59.25c-6.6,0-12-5.4-12-12v-48.78c0-3.92,1.91-7.42,4.84-9.62.32-.24.65-.46,1-.66.88-.54,1.83-.96,2.84-1.25,1.01-.29,2.07-.46,3.17-.47h83.18c1.1.02,2.16.18,3.17.47,1.01.3,1.97.72,2.85,1.25.66.4,1.28.86,1.85,1.37,2.43,2.21,3.97,5.39,3.97,8.91Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 78.7,
    cy: 96.5,
    r: 8.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 122.68,
    cy: 96.5,
    r: 8.35
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m70.35,111.54h60.68c0,9.37-7.61,16.98-16.98,16.98h-26.72c-9.37,0-16.98-7.61-16.98-16.98h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m163.19,20.96v18.26c0,6.55-5.36,11.9-11.9,11.9h-8.62l-10.2,10.26v-10.26h-65.91c-6.55,0-11.9-5.36-11.9-11.9v-18.26c0-6.55,5.36-11.9,11.9-11.9h84.73c6.55,0,11.9,5.36,11.9,11.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m155.4,13v18.41c0,6.6-5.4,12-12,12h-8.69l-10.28,10.35v-10.35H57.97c-6.6,0-12-5.4-12-12V13c0-6.6,5.4-12,12-12h85.43c6.6,0,12,5.4,12,12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "133.54 13.55 130.72 19.24 124.43 20.16 128.98 24.59 127.91 30.86 133.54 27.9 139.16 30.86 138.09 24.59 142.64 20.16 136.35 19.24 133.54 13.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "111.64 13.55 108.83 19.24 102.54 20.16 107.09 24.59 106.02 30.86 111.64 27.9 117.26 30.86 116.19 24.59 120.74 20.16 114.45 19.24 111.64 13.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "89.75 13.55 86.93 19.24 80.64 20.16 85.19 24.59 84.12 30.86 89.75 27.9 95.37 30.86 94.3 24.59 98.85 20.16 92.56 19.24 89.75 13.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "67.85 13.55 65.04 19.24 58.75 20.16 63.3 24.59 62.23 30.86 67.85 27.9 73.47 30.86 72.4 24.59 76.95 20.16 70.66 19.24 67.85 13.55"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetterThanReviewSitesWhite);
export default __webpack_public_path__ + "static/media/betterThanReviewSitesWhite.cd64a86bd20f02fa3d9890a84320845c.svg";
export { ForwardRef as ReactComponent };